// should be FieldInputType
enum FieldType {
  TEXT = 'INPUT_TEXT',
  TEXT_AREA = 'INPUT_TEXT_AREA',
  NUMERIC = 'INPUT_NUMERIC',
  SINGLE_SELECT = 'INPUT_SINGLE_SELECT',
  MULTI_SELECT = 'INPUT_MULTI_SELECT',
}

export default FieldType;
